import { useEffect, useId, useState } from "react";
import { Box, Button, CircularProgress, Collapse, Typography } from "@mui/material";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { chatbotPalette } from "./chatbotTheme";

export default function ChatActivity({ steps = [], durationSec = 0, isLive = false, liveStep = "", failed = false }) {
  const [open, setOpen] = useState(false);
  const detailsId = useId();
  useEffect(() => { if (!isLive) setOpen(false); }, [isLive]);
  const source = [...steps, ...(isLive && liveStep ? [liveStep] : [])].filter(step => typeof step === "string" && step.trim()).map(step => step.trim());
  // Retain each activity's most recent occurrence so the active step stays last.
  const unique = source.filter((step, index) => source.lastIndexOf(step) === index);
  const latest = unique[unique.length - 1] || "กำลังตรวจสอบข้อมูล";
  const seconds = Math.max(0, Math.floor(Number(durationSec) || 0));
  return <Box sx={{ mb: 0.75 }}>
    {isLive && <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
      <CircularProgress size={12} sx={{ color: chatbotPalette.teal, flexShrink: 0 }} />
      <Typography role="status" sx={{ color: chatbotPalette.textMain, fontSize: 13 }}>{latest}</Typography>
      <Typography sx={{ color: chatbotPalette.textMuted, fontSize: 12, whiteSpace: "nowrap" }}>{seconds} วินาที</Typography>
    </Box>}
    <Button size="small" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-controls={detailsId}
      startIcon={open ? <KeyboardArrowDownRoundedIcon /> : <KeyboardArrowRightRoundedIcon />}
      sx={{ p: 0, minHeight: 32, color: chatbotPalette.textMuted, fontSize: 12, textTransform: "none", textAlign: "left" }}>
      {isLive ? "ดูขั้นตอนการทำงาน" : `${failed ? "การทำงานหยุดลง" : "ดำเนินการแล้ว"} · ${seconds} วินาที`}
    </Button>
    <Collapse in={open} unmountOnExit><Box id={detailsId} component="ul" sx={{ m: 0, mt: 0.5, pl: 2.5, borderLeft: `1px solid ${chatbotPalette.borderSoft}` }}>
      {unique.length ? unique.map((step, index) => <Box component="li" key={step} sx={{ color: isLive && index === unique.length - 1 ? chatbotPalette.teal : chatbotPalette.textMuted, py: 0.4, fontSize: 12, overflowWrap: "anywhere" }}>{step}</Box>) : <Typography sx={{ color: chatbotPalette.textMuted, fontSize: 12 }}>ไม่มีรายละเอียดขั้นตอนเพิ่มเติม</Typography>}
    </Box></Collapse>
  </Box>;
}
